import { useEffect, useState } from 'react';
import { useConnectionObjectApi } from '../Services/ConnectionObjectApiProvider';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Table from '../Components/Tables';
import { formatDateUTC } from '../utils/formatDate';
import { getTablePaginationFromStorage } from '../utils/tablePaginationStorage';
import { formatTableTitle } from '../utils/formatTitle';

function ConnectionObjectsList() {
  const { getObjectsByConnectionId } = useConnectionObjectApi();
  const { organizationId, connectionId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [objects, setObjects] = useState([]);
  const [totalCountObjects, setTotalCountObjects] = useState(0);

  const tableTitle = 'Connection Objects List';
  const { persistedPageSize, persistedSkip } = getTablePaginationFromStorage(
    formatTableTitle(tableTitle),
  );

  const columns = [
    { name: 'ID', selector: (row) => row.id },
    { name: 'Name', selector: (row) => row.name },
    { name: 'Type', selector: (row) => row.type },
    { name: 'Status', selector: (row) => (row.is_active ? 'Active' : 'Inactive') },
    { name: 'Created', selector: (row) => formatDateUTC(row.created_at) },
  ];

  const fetchObjects = async (connectionId, skip, limit) => {
    try {
      setLoading(true);
      const response = await getObjectsByConnectionId(connectionId, skip, limit);
      setObjects(response.items);
      setTotalCountObjects(response.totalCount);
    } catch (err) {
      console.error('Error fetching Connection Objects:', err);
      setError('Failed to load Connection Objects');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchObjects(connectionId, persistedSkip, persistedPageSize);
  }, [connectionId, persistedSkip, persistedPageSize]);

  const handleRowClick = (row) => {
    console.log('location.pathname', location.pathname);
    navigate(`/organizations/${organizationId}/connection-objects/${row.id}`, {
      state: {
        from: location.pathname,
        activeTab: 'view-objects',
      },
    });
  };

  return (
    <>
      {error ? (
        <div>Error: {error}</div>
      ) : (
        <Table
          title={tableTitle}
          columns={columns}
          data={objects}
          onRowClicked={handleRowClick}
          selectableRowsHighlight
          progressPending={loading}
          paginationPerPage={persistedPageSize}
          paginationTotalRows={totalCountObjects}
          sortIcon={<i className="fa-solid fa-chevron-down"></i>}
          onChangePage={fetchObjects}
        />
      )}
    </>
  );
}

export default ConnectionObjectsList;
